<template><div><h1>VUX V2.3.5 发布日志</h1>
<h2><a href="/zh-CN/components/actionsheet.html">Actionsheet</a></h2>
<ul><li>[feature] 支持 slot:header #1381</li>
</ul>
<h2><a href="/zh-CN/components/inline-calendar.html">InlineCalendar</a></h2>
<ul><li>[feature] 支持自定义每一天的 html 渲染 slot:each-day</li>
</ul>
<h2><a href="/zh-CN/components/radio.html">Radio</a></h2>
<ul><li>[feature] 支持自定义渲染每一列 slot:each-item</li>
</ul>
<h2><a href="/zh-CN/components/search.html">Search</a></h2>
<ul><li>[feature] 增加 slot:left</li>
</ul>
<h2><a href="/zh-CN/components/swiper.html">Swiper</a></h2>
<ul><li>[fix] 修复重复渲染问题 #1458</li>
</ul>
<h2><a href="/zh-CN/components/tab.html">Tab</a></h2>
<ul><li>[feature] 支持设置 badge #1513</li>
</ul></div></template><script>
export default {
  head: {"title":"VUX V2.3.5 发布日志 | VUX - 基于 WeUI 和 Vue 的移动端组件库","ignoreSuffixChar":"|"}
}
  </script>


// WEBPACK FOOTER //
// v2.3.5-238.vue?754fa340